import React from "react";
// import {Link} from 'react-router-dom';

function Why() {
  return (
    <>
      <div id="why" className="container-fluid">
        <div className="row why_row">
          <h2 className="why-head heading">Why hold $LITTLE Token?</h2>
          <div className="col-sm-7" style={{margin:"auto"}}>
            <ul className="social-network social-circle">
              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why1.png"} alt="whyy"/>
                  </li>
                  <li className="why para home_para">
                    <p>
                      Be compensated for holding $LITTLE on a daily basis with
                      <br />
                      MATIC in your wallet
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why2.png"} alt="whyy"/>
                  </li>
                  <li className="why para home_para">
                    <p>
                      Constant liquidity providing through investing <br />
                      transaction fees.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why3.png"} alt="whyyimg"/>
                  </li>
                  <li className="why para home_para">
                    <p>
                      Constant Value providing through investing royalties and
                      fees<br/> in buying and burning $LITTLE.
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <ul className="social">
                  <li className="icon-text effecthov">
                    <img src={"images/why4.png"} alt="whyyimg"/>
                  </li>
                  <li className="why para home_para">
                    <p>
                      IPCO price of 0.15$ 30 days after the mint while price is
                      fixed<br/> at 0.05$ directly after mint.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="col-sm-5 picture" style={{margin:"auto"}}>
            <img src={"images/6.png"} alt="float" className="why-pic floating" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Why;
